<template>
<!-- <div :class="seatLoading?'metaportal_fn_wallet_closer ready':' metaportal_fn_wallet_closer ready active'"> -->
  <div class="container" v-if="seatLoading">
  <div class="loaderWraper"><img :src="imgPath+'images/palaxi.gif'" width="100" style="z-index: 1001;"></div>
</div>


  <div class="container" v-if="!seatLoading">
    <div class="" style="position: relative;">

      <div class="" style="width: 100%;position: relative;">
        <div class="seats col-md-12 nopad  text-center">
          <div class="fulwid">
            <div class="setxs" style="">
              <div id="seatWrprOuter" style="">
                <div v-for="(cls, index) in seatClass" :key="index">
                  <div class="seat-wrapper " data-class="Platinum(Recliner)">
                    <div class="classname">
                      <h4 class="class-head">{{ cls.name }} ₹{{ cls.amount }}
                      </h4>
                    </div>
                  </div>
                  <div class="seat-wrapper  cls4" data-class="Silver" v-for="(row, key) in seatLayout[index]" :key="key">
                    <button id="st101" @click="clickSeat(seat)"
                      :class="getStyle(seat.empty, seat.typ, seat.bsts,seat.classname,seat.clsts)" :data-id="seat.id"
                      v-for="(seat, pos) in row" :key="pos">{{ setName(seat.name, seat.typ) }}</button>
                  </div>
                </div>
              </div>

            </div>

            
          </div>
          <p class="row marg3">
          </p>
        </div>
      </div>

    </div>
  </div>

  <div class="container">
    <div class="screen" style="margin-top: 0px; margin-bottom: 0px;margin-left: auto;margin-right: auto;">
            </div>
            <div
              style="text-align: center;margin-top: -48px;z-index: 1000000 !important;color: #333;position: relative;margin-bottom: 40px;">
             Screen</div>
            <div style="text-align: center;padding-bottom: 205px;padding-top: 10px;" class="col-md-12 "> <button
          style="cursor: not-allowed;transition: all 300ms ease-in-out;background-color: #cacaca;height: 16px !important;width: 19px !important;border-top-left-radius: 10px;border-top-right-radius: 10px;border: none;vertical-align: middle;"></button>
        <span class="font15" style="padding-right: 10px;color: #686868;font-size: 12px;"> Available </span> <button
          style="cursor: not-allowed;transition: all 300ms ease-in-out;background: #6feaf6;height: 16px;width: 19px;border-top-left-radius: 10px;border-top-right-radius: 10px;border: none;vertical-align: middle;">
        </button> <span class="font15" style="padding-right: 10px;color: #686868;font-size: 12px;">Selected</span> <button
          style="vertical-align: middle;cursor: not-allowed;transition: all 300ms ease-in-out;background: #e10018;height: 16px;width: 19px;border-top-left-radius: 10px;border-top-right-radius: 10px;border: none;">
        </button> <span class="font15" style="color: #686868;font-size: 12px;">Sold</span> </div>
</div>

</template>
<style type="text/css">
  .couple{margin:3px 0px!important;}
  .launcher{height: 35px!important;}
</style>

<script>
import axios from 'axios';
import { Modal } from 'bootstrap';
import { URL } from '@/conf.js';
export default {
  props: {
    showId: { default: null }
  },
  data: () => ({
    seatStyles: { "100": "fade", "000": "btn-seat", "030": "bt-label", "020": "btn-seatbook", "001": "btn-seatbook", "0001": "btn-seat-selected" },
    seatLoading: true,
    response: [],
    seatClass: {},
    seatRows: {},
    seatLayout: {},
    timer: null,
    selectedSeats: [],
    blockedSteats: [],
    imgPath: process.env.BASE_URL,
    poceedBooking: false,
    offline:false,
    uniqueModal:null
    

  }),
  methods: {
    getSeatLayout() {
      this.poceedBooking = false;
      this.selectedSeats = [];
      axios.get(URL + "seatLayout/" + this.$route.params.showid).then((response) => {
        this.response = response.data.result;
        this.seatClass = this.response.classes;
        this.seatLayout = this.response.seats;
        this.seatLoading = false;
      }).then(() => {
        this.getBlockedSeats();
      });

    },
    getBlockedSeats() {
      axios.get(URL + "blockedSeats/" + this.$route.params.showid).then((response) => {
        this.seatLoading = false;
        document.getElementById('loadOver').style.display="none";
        this.poceedBooking = true;
        if (response.data.sts == "offline") {
          this.offline = true;
    this.showUniqueModal();

        }
        this.blockedSteats = response.data.result;
        if (this.blockedSteats) {
          let sckeys = Object.keys(this.seatLayout);
          sckeys.forEach((sckey) => {
            let rowseats = this.seatLayout[sckey];
            let rskeys = Object.keys(rowseats);
            rskeys.forEach((rskey) => {
              for (let seat of rowseats[rskey]) {
                if (this.selectedSeats.includes(seat.id)) {
                  continue;
                }
                if (this.blockedSteats.includes(seat.id)) {
                  seat.bsts = 1;
                } else {
                  seat.bsts = 0;
                }
              }
            });
          });
        }
      })
    },
    clickSeat(itm) {
      if (itm.typ != 0 || itm.empty || itm.bsts) {
        return
      }
      if (this.selectedSeats.length > 0 && this.selectedSeats[0].clid != itm.clid) {
        return
      }
      if (itm.clsts) {
        delete itm["clsts"];
      } else {
        if (this.selectedSeats.length >= 10) {
          return
        }
        itm["clsts"] = 1;
      }
      let pos = this.selectedSeats.indexOf(itm);
      if (pos !== -1) {
        this.selectedSeats.splice(pos, 1);
      } else {
        this.selectedSeats.push(itm)
      }
      this.$emit('seatclicked', this.selectedSeats);
    },
    getStyle(empty, typ, bsts,custcls="",clsts="") {

      let key = empty + "" + typ + bsts+ clsts ;
      // return key;
      return custcls+" "+this.seatStyles[key];

    },
    setName(stname, typ) {
      return typ == 3 ? stname : stname.replace(/\D/g, '')
    },
    showUniqueModal() {
      this.uniqueModal = new Modal(document.getElementById("uniqueId"),{ keyboard: false });
      this.uniqueModal.show();
      },
     closeUniqueModal() {
      this.uniqueModal.hide();
     },
  },
  created() {
    this.$watch(
      () => this.$route.params,
      () => {
        this.getSeatLayout();
      }
    )
  },
  mounted() {
  
    this.getSeatLayout();
    this.timer = setInterval(this.getBlockedSeats, 20000)
  },
  unmounted() {
    clearInterval(this.timer);
  }, emits: ["seatclicked"]
}
</script>